import { Injectable } from "@angular/core";
import { UserProvider } from "../../providers/user/user";
import { Observable } from "rxjs/Observable";
import { ListasProvider } from "../../providers/listas/listas";
import { DomSanitizer } from "@angular/platform-browser";
import { EventoAdversoModel } from "./evento-adverso.modelview";
import { AdverseEventsProvider } from "../../providers/adverses/adverses";
import { ProdutosProvider } from "../../providers/products/products";

@Injectable()
export class EventoAdversoPageProvider {

    constructor(
        public adverseEventsProvider: AdverseEventsProvider,
        public listsProvider: ListasProvider,
        public sanitizen: DomSanitizer,
        public userProvider: UserProvider,
        public productProvider: ProdutosProvider
    ) { }

    enviarEventoAdverso(model: EventoAdversoModel): Observable<any> {
        return this.adverseEventsProvider.sendAdverseEvents(model)
    }

    requestLists(): Observable<any> {
        return this.listsProvider.requestAllLists()
    }

    requestProducts(): Observable<any> {
        return Observable.create((sub) => {

            this.productProvider.requestProducts().subscribe(products => {
                var names = []

                products.forEach(element => {
                    names.push(element.title.rendered)
                });

                sub.next(names)
            }, (err) => {
                sub.console.erro(err);
            })

        })
    }

    getUserData(): Observable<any> {
        return Observable.create(subscribe => {
            subscribe.next(this.userProvider.getUserStoraged())
        })
    }
}


// WEBPACK FOOTER //
// ./src/pages/evento-adverso/evento-adverso.provider.ts